import styled from 'styled-components';

export const Input = styled.input`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  width: 100%;
  border: none;
  border-bottom: 1px solid lightgrey;
  background: none;
  padding-bottom: 10px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-bottom: 1px solid
      ${(props) => props.theme.atlas.semantic.color.ui.loading.default};
  }
`;
